import React from 'react';
export const MarkupEditorComponent = function MarkupEditorComponent({ editor, autofocus, className, children }) {
    const ref = React.useRef(null);
    // insert editor to dom
    React.useLayoutEffect(() => {
        const domElem = editor.markupEditor.cm.getWrapperElement();
        if (ref.current) {
            ref.current.appendChild(domElem);
        }
        return () => {
            domElem.remove();
        };
    }, [editor.markupEditor]);
    // update editor after connecting to dom
    React.useEffect(() => {
        editor.markupEditor.cm.refresh();
        if (autofocus) {
            editor.markupEditor.focus();
        }
    }, [editor.markupEditor]);
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React.createElement("div", { ref: ref, className: className, onClick: (event) => {
            const target = event.target;
            if (target instanceof Element && target.classList.contains('CodeMirror')) {
                editor.markupEditor.focus();
            }
        } }, children));
};
